import api from "../utils/api";

const BASE = "/tickets";
const LOCAL_STORAGE_KEY = 'step4_tickets_mock';

// Seed initial mock tickets if none exist in localStorage
const SEED_TICKETS = [
  {
    id: 'TKT-1001',
    subject: 'Meter M-019 reporting 0 scale factor',
    description: 'The scale factor for meter M-019 was observed to be 0 since yesterday. Power readings are showing up as 0 as well. Please review configuration.',
    client_name: 'Al-Hamd Textiles',
    meter_id: 'M-019',
    machine_name: 'Main Generator',
    category: 'Inaccurate Readings',
    priority: 'High',
    status: 'In Progress',
    created_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    created_by: 'manager_ahmed',
  },
  {
    id: 'TKT-1002',
    subject: 'Missing data gap on solar inverter meter',
    description: 'We detected a 4-hour missing data gap on 25th July from 12:00 to 16:00. This is affecting the daily production charts.',
    client_name: 'Khaadi Packaging',
    meter_id: 'SOL-004',
    machine_name: 'Solar Inverter 1',
    category: 'Missing Data',
    priority: 'Medium',
    status: 'Open',
    created_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString(),
    created_by: 'khaadi_admin',
  },
  {
    id: 'TKT-1003',
    subject: 'Disconnected status alert trigger',
    description: 'Meter has been disconnected for more than 48 hours. No physical damage seen, but status shows Offline.',
    client_name: 'Gul Ahmed Foods',
    meter_id: 'M-102',
    machine_name: 'Packaging Line 3',
    category: 'Offline Meter',
    priority: 'Urgent',
    status: 'Closed',
    created_at: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    updated_at: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    created_by: 'gulahmed_user',
  },
];

function getLocalTickets() {
  const data = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!data) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(SEED_TICKETS));
    return SEED_TICKETS;
  }
  try {
    return JSON.parse(data);
  } catch (err) {
    return SEED_TICKETS;
  }
}

function saveLocalTickets(tickets) {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(tickets));
}

/**
 * Fetch all tickets for the client
 */
export async function getTickets(username) {
  try {
    const response = await api.get(BASE, { params: { username } });
    if (response.data && Array.isArray(response.data.tickets)) {
      return response.data.tickets;
    }
  } catch (err) {
    console.warn('Backend API /tickets unavailable, falling back to localStorage:', err);
  }

  // Fallback to localStorage
  // Filter by username if username is provided
  const tickets = getLocalTickets();
  if (username) {
    return tickets.filter(t => t.created_by.toLowerCase() === username.toLowerCase());
  }
  return tickets;
}

/**
 * Create a new complaint ticket
 */
export async function createTicket(req, username) {
  const payload = {
    ...req,
    created_by: username,
  };

  try {
    const response = await api.post(BASE, payload);
    if (response.data && response.data.ticket) {
      return response.data.ticket;
    }
  } catch (err) {
    console.warn('Backend API POST /tickets unavailable, saving to localStorage:', err);
  }

  // Local storage save
  const tickets = getLocalTickets();
  const nextNum = tickets.reduce((max, t) => {
    const num = parseInt(t.id.split('-')[1]);
    return isNaN(num) ? max : Math.max(max, num);
  }, 1000) + 1;

  const newTicket = {
    id: `TKT-${nextNum}`,
    ...req,
    status: 'Open',
    created_by: username,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  };

  tickets.unshift(newTicket);
  saveLocalTickets(tickets);
  return newTicket;
}
